import { Component, ElementRef, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../_common/_service/authservice.service';
import { ConfirmPasswordValidator } from '../../../_common/_helper/confirm-password.validator';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { DatePipe, formatDate } from '@angular/common';

export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

@Injectable()
class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return formatDate(date, 'dd-MM-yyyy', this.locale);
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
    ]
})
export class SignupComponent implements OnInit {
  showModal: boolean;
  loadingspinner: boolean = false;
  submitted = false;
  signupForm: FormGroup;
  countryList: any;
  currentDate = new Date();

  errorMessage = '';
  ipAddress: any;
  hide1 = true;
  hide2 = true;
  something = null;
  SignUpcountryIsdcode: any;
  userAgent: any;
  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();

  constructor(private fb: FormBuilder, public dialog: MatDialog, private authService: AuthService,
    private toastr: ToastrService, public dialogRef: MatDialogRef<SignupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private tokenStorageService: TokenStorageService,
    public datepipe: DatePipe
  ) {

    this.showModal = true;
   
    this.signupForm = this.fb.group({
      //firstName: [null, [Validators.required, Validators.maxLength(50)]],
      //lastName: [null, [Validators.required, Validators.maxLength(50)]],
      emailId: [null, [Validators.required, Validators.email]],
      countryId: [127],
      mobileNo: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(13), Validators.minLength(5)]],
      //password: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
      //confirmPassword: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],

      password: [null, [Validators.required, Validators.maxLength(8), Validators.minLength(20)]],
      confirmPassword: [null, [Validators.required, Validators.maxLength(8), Validators.minLength(20)]],

      userDeviceType: 0,
      userDeviceToken: null,
      //UserRoleType: 15,
      //DOB: [null, [Validators.required]],
      ipAddress: null
    }, {
        validator: ConfirmPasswordValidator('password', 'confirmPassword')
    })
  }

  ngOnInit(): void {
    this.userAgent = window.navigator.userAgent;
  
    this.getIPAddress();
    this.getIsdCode();
    // listen for search field value changes
    this.CountryFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCountry();
      });

  }

  getIPAddress() {
    const response = fetch('https://api.ipify.org/?format=json')
      .then(response => response.json())
      .then(data => {
        this.ipAddress = data.ip;
      });
  }
//  {
//  "firstName": "xyz",
//    "lastName": "xyz",
//      "emailId": "xyz@gmail.com",
//        "password": "xyz@123",
//          "isdCode": "91",
//            "mobileNo": "7897887810",
//              "userDeviceType": 0,
//                "userDeviceToken": "string",
//                  "ipAddress": "198.168.1.1"
//}

  // convenience getter for easy access to form fields
  get f() { return this.signupForm.controls; }
  
  signup(post: any) {
    
    this.submitted = true;

    if (this.signupForm.valid) {
      this.loadingspinner = true;

      //var dt1 = this.datepipe.transform(this.f.DOB.value, 'yyyy-MM-dd');
      //post.DOB = dt1;


      post.IPAddress = this.ipAddress;


      
      
      this.authService.signup(post).subscribe((response: { apiStatus: any; apiMessage: any; }) => {
        ;
        this.loadingspinner = false;
        if (response.apiStatus == true) {
          //if (usrData != null) {
          //if (usrData.IsEmailVerified == true) { //IsEmailVerified only login
          //  this.toastr.success(response.message, "Error");
          //  this.dialogRef.close();
          //this code below is on sign up successful & this below code how we use refer & earn
          //window.sessionStorage.setItem('LoggedInflag', 'signuptrue');
          //window.sessionStorage.setItem('EmailIdflag', usrData.EmailId);
          //window.sessionStorage.setItem('MobileNoflag', usrData.MobileNo);
          //window.sessionStorage.setItem('FirstNameflag', usrData.FirstName);
          //window.location.reload();
          //}
          //else {
         // this.toastr.success("Registration Successfull. Please Verify Your Email For Login", "Success");
          this.toastr.success(response.apiMessage, 'Success');
          this.dialogRef.close();
          //}
          // }

        } else {
          this.toastr.error(response.apiMessage, "Error");
        }

      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }

  getIsdCode() {

    
    this.submitted = true;
    this.authService.getIsdCodeSignup().subscribe((response: { apiData: any; apiMessage: any; }) => {
     
      this.countryList = response.apiData;
    }, (err: any) => {
        
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  filterCountry() {

    if (this.CountryFilterCtrl.value) {
      //return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().indexOf(this.CountryFilterCtrl.value.toLowerCase()) > -1);
      return this.countryList.filter((x: { Name: string; }) => x.Name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }


  SetCountryCode(isdCodeText: any) {
    this.SignUpcountryIsdcode = isdCodeText;

  }
}
